import { render, staticRenderFns } from "./SplitBar.vue?vue&type=template&id=8721292e&scoped=true&"
import script from "./SplitBar.vue?vue&type=script&lang=js&"
export * from "./SplitBar.vue?vue&type=script&lang=js&"
import style0 from "./SplitBar.vue?vue&type=style&index=0&id=8721292e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8721292e",
  null
  
)

export default component.exports